import React, {useState} from "react";
import TokenStatus from "../components/TokenStatus";
import GatewayTest from "./GatewayTest";
import BridgeTest from "./BridgeTest";
import ServiceTest from "./ServiceTest";
import ConsentTest from "./ConsentTest";
import RegistrationCallback from "./RegistrationCallback";
import OnRequestCallback from "./OnRequestCallback";
export default function AdminDashboard() {
    const [page, setPage] = useState("gateway");
    return (<div className="container-fluid">

        <div className="row">

            <div className="col-lg-3">

                <div className="card shadow-sm abdm-sidebar">

                    <div className="card-header bg-primary text-white">

                        <strong>

                            ABDM Admin

                        </strong>

                    </div>

                    <div className="list-group list-group-flush abdm-menu">

                        <button
                            className={page === "gateway" ? "list-group-item list-group-item-action active" : "list-group-item list-group-item-action"}
                            onClick={() => setPage("gateway")}
                        >
                            Gateway Session
                        </button>

                        <button
                            className={page === "bridge" ? "list-group-item list-group-item-action active" : "list-group-item list-group-item-action"}
                            onClick={() => setPage("bridge")}
                        >
                            Update Bridge
                        </button>

                        <button
                            className={page === "services" ? "list-group-item list-group-item-action active" : "list-group-item list-group-item-action"}
                            onClick={() => setPage("services")}
                        >
                            Services
                        </button>

                        <button
                            className={page === "registration" ? "list-group-item list-group-item-action active" : "list-group-item list-group-item-action"}
                            onClick={() => setPage("registration")}
                        >
                            Registration Callback
                        </button>

                        <button
                            className={page === "request" ? "list-group-item list-group-item-action active" : "list-group-item list-group-item-action"}
                            onClick={() => setPage("request")}
                        >
                            On Request Callback
                        </button>

                        <button
                            className={page === "consent" ? "list-group-item list-group-item-action active" : "list-group-item list-group-item-action"}
                            onClick={() => setPage("consent")}
                        >
                            Consent
                        </button>

                    </div>

                </div>

                <div className="mt-3">

                    <TokenStatus/>

                </div>

            </div>

            <div className="col-lg-9">

                {page === "gateway" && <GatewayTest/>}

                {page === "bridge" && <BridgeTest/>}

                {page === "services" && <ServiceTest/>}

                {page === "registration" && <RegistrationCallback/>}

                {page === "request" && <OnRequestCallback/>}

                {page === "consent" && <ConsentTest/>}

            </div>

        </div>

    </div>);
}